import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { useAuth } from '../hooks/useAuth';

interface LoginFormProps {
  onLoginSuccess?: () => void;
  onSwitchToSignUp?: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onLoginSuccess, onSwitchToSignUp }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { login, isLoading, error } = useAuth();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        const success = await login({ email, password });
        
        if (success) {
            // ログイン成功をコンソールに表示
            console.log('ログイン成功');
            // ログイン成功時のコールバック実行
            onLoginSuccess?.();
            // フォームをリセット
            setEmail('');
            setPassword('');
            // ページをリロードして認証状態を反映
            window.location.reload();
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 sm:p-6">
            <Card className="w-full max-w-md">
                <CardHeader className="text-center px-4 sm:px-6">
                    <CardTitle className="text-xl sm:text-2xl font-bold text-gray-900">
                        サブスクナビ
                    </CardTitle>
                    <CardDescription className="text-base sm:text-sm">
                        アカウントにログインしてください
                    </CardDescription>
                </CardHeader>
                <CardContent className="px-4 sm:px-6">
                    <form onSubmit={handleSubmit} className="space-y-4">
                        {error && (
                            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md text-sm">
                                {error.message}
                            </div>
                        )}
                        <div className="space-y-2">
                            <Label htmlFor="email" className="text-base sm:text-sm">メールアドレス</Label>
                            <Input
                                id="email"
                                type="email"
                                placeholder="your@example.com"
                                value={email}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                required
                                disabled={isLoading}
                                autoComplete="email"
                                inputMode="email"
                            />
                        </div>
                        <div className="space-y-2">
                            <Label htmlFor="password" className="text-base sm:text-sm">パスワード</Label>
                            <Input
                                id="password"
                                type="password"
                                placeholder="パスワードを入力"
                                value={password}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                                required
                                disabled={isLoading}
                                autoComplete="current-password"
                            />
                        </div>
                        <Button 
                            type="submit" 
                            className="w-full" 
                            disabled={isLoading}
                        >
                            {isLoading ? 'ログイン中...' : 'ログイン'}
                        </Button>
                    </form>
                    <div className="mt-6 text-center space-y-3">
                        <p className="text-sm sm:text-sm text-gray-600">
                            アカウントをお持ちでない場合は{' '}
                            <button 
                                type="button"
                                onClick={onSwitchToSignUp}
                                className="text-blue-600 hover:underline font-medium touch-manipulation"
                            >
                                新規登録
                            </button>
                        </p>
                        <p className="text-sm sm:text-sm text-gray-600">
                            すでにログイン済みの場合は{' '}
                            <a 
                                href="/dashboard"
                                className="text-green-600 hover:underline font-medium"
                            >
                                ダッシュボードへ
                            </a>
                        </p>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default LoginForm;
